export const FETCH_DASHBOARD_DETAILS = "FETCH_DASHBOARD_DETAILS";
export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS";
export const FETCH_ACTIVE_CUSTOMERS = "FETCH_ACTIVE_CUSTOMERS";
export const FETCH_INACTIVE_CUSTOMERS = "FETCH_INACTIVE_CUSTOMERS";
export const FETCH_CUSTOMER_DETAILS = "FETCH_CUSTOMER_DETAILS";
export const FETCH_CUSTOMER = "FETCH_CUSTOMER";
export const INSERT_CUSTOMER = "INSERT_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const CHANGE_STATUS_CUSTOMER = "CHANGE_STATUS_CUSTOMER";
export const INSERT_EXPENSE = "INSERT_EXPENSE";
export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const INSERT_RECEIVE = "INSERT_RECEIVE";
export const UPDATE_RECEIVE = "UPDATE_RECEIVE";
export const DELETE_RECEIVE = "DELETE_RECEIVE";
export const SUCCESS = "success";
export const PENDING = "pending";
export const ERROR = "error";
export const RESET_STATUS = "RESET_STATUS";
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_NOT_FOUND = "LOGIN_USER_NOT_FOUND";
